import {
  Autocomplete,
  AutocompleteOption,
  Button,
  Checkbox,
  CircularProgress,
  createFilterOptions,
  DialogContent,
  Drawer,
  Input,
  Option,
  Select,
  selectClasses,
  TextField,
} from "@mui/joy";
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../appConstants";
import { useEffect, useState } from "react";
import Joi from "joi";
import PaginationComponent from "../commonComponents/PaginationComponent";
import { debounce, filter, set } from "lodash";
import axios from "axios";
import appError from "../../appError";
// import ArchiveToggle from "./ArchiveToggle";
import MultiSelect from "../commonComponents/MultiSelect";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { UUID } from "crypto";
import MultiSelectSearchComponent from "./MultiSelectSearchComponent";
import { isTemplateSpan } from "typescript";

type AddKeywordProps = {
  targeting: string;
  bcg_type: string;
};
type Categories = {
  principal_category: string;
  principal_category_id: string;
  main_category: string;
  main_category_id: string;
  category: string;
  category_id: string;
  sub_category: string;
  sub_category_id: string;
};
type FilterStateObj = {
  principal_category: string;
  main_category: string;
  category: string;
  sub_category: string;
  limit: number;
  page: number;
};
type CreateState = {
  principal_id: string | null;
  main_cat_id: string | null;
  sub_cat_id: string | null;
  cat_id: string | null;
  principal_category: string;
  main_category: string;
  category: string;
  sub_category: string;
  status: string;
  cat_level: number;
};

type SuggestPrincipal = {
  principal_category: string;
  principal_category_id: string;
};

type SuggestMain = {
  main_category: string;
  main_category_id: string;
};
type SuggestCategory = {
  category: string;
  category_id: string;
};
type SuggestSubCategory = {
  sub_category: string;
  sub_category_id: string;
};

type filterPrincipal = {
  id: string;
  label: string;
};

const CategoryList: React.FC = () => {
  const [filterToggle, setFilterToggle] = useState<boolean>(false);
  const [addKeywordToggle, setAddKeywordToggle] = useState<boolean>(false);
  const [dataFetchingState, setDataFetchingState] = useState<string>("LOADING");
  const [totalRows, setTotalRows] = useState<number>(0);
  const brandData = localStorage.getItem("brand")
    ? JSON.parse(localStorage.getItem("brand") as string)
    : null;
  const [selectedBrandId, setSelectedBrandId] = useState<string>(
    brandData && brandData?.brand_id
  );
  const [saveloading, setSaveLoading] = useState<boolean>(false);
  const [editloading, setEditLoading] = useState<boolean>(false);
  const [filterloading, setFilterLoading] = useState<boolean>(false);
  const [editToggle, setEditToggle] = useState<boolean>(false);
  const [categories_arr, setCategories_arr] = useState<Categories[]>([]);
  const [hierarchy_level, SetHierarchy_level] = useState<number>(
    brandData && brandData?.category_hierarchy_level
  );
  const [filterState, setFilterState] = useState<FilterStateObj>({
    principal_category: "",
    main_category: "",
    category: "",
    sub_category: "",
    limit: 10,
    page: 1,
  });
  const [createState, setCreateState] = useState<CreateState>({
    principal_id: "",
    main_cat_id: "",
    sub_cat_id: "",
    cat_id: "",
    principal_category: "",
    main_category: "",
    category: "",
    sub_category: "",
    status: "ACTIVE",
    cat_level: 0,
  });
  const [othername, setOtherName] = useState<string>("");
  const [suggestPrincipals, setSuggestPrincipals] = useState<
    SuggestPrincipal[]
  >([]);
  const [suggestMains, setSuggestMains] = useState<SuggestMain[]>([]);
  const [suggestCategorys, setSuggestCategorys] = useState<SuggestCategory[]>(
    []
  );
  const [suggestSubCategorys, setSuggestSubCategorys] = useState<
    SuggestSubCategory[]
  >([]);

  // ------------------ FILTER DRAWER
  // 1. Principle Category
  type FilterPrincipleStateObj = {
    full_name?: string;
    limit: number;
    page: number;
  };
  const [filterPrincipleState, setFilterPrincipleState] =
    useState<FilterPrincipleStateObj>({
      full_name: "",
      limit: 10,
      page: 1,
    });
  const [selectedPrinciples, setSelectedPrinciples] = useState<Set<string>>(
    new Set([])
  );
  const [filtersearchPrinciples, setFilterSearchPrinciples] = useState<
    filterPrincipal[]
  >([]);
  const [filterPrinciples, setFilterPrinciples] = useState<filterPrincipal[]>(
    []
  );
  const [FilterFocus, setFilterFocus] = useState<boolean>(false);
  const [filterPrinciple, setFilterPrinciple] = useState<string>("");
  const [selectedPriciplesValue, setSelectedPrinciplesValue] =
    useState<string>("Search Value");
  const fetchFilterValues = debounce(
    async (data_name: string, filter: string) => {
      const token = localStorage.getItem("token");

      // Ensure you use the correct base URL and filterPrinciple
      let api = `${BASE_URL}brand/getSuggestCategories?principal_category=${filterPrinciple}&brand_id=${selectedBrandId}&type=PRINCIPAL`;

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      try {
        const result = await axios.get(api, { headers });
        type principal = {
          principal_category_id: string;
          principal_category: string;
        };
        const { principal_category_array } = result?.data?.data;
        const converted_arr = principal_category_array.map(
          (item: principal) => ({
            id: item?.principal_category_id,
            label: item?.principal_category,
          })
        );

        // Use the response data for different actions based on `data_name` and `filter`
        setFilterPrinciples(converted_arr);
      } catch (error) {
        appError(error);
      } finally {
        // Optionally handle any cleanup or final actions
      }
    },
    500
  );

  const onPrincipleCatInputChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (e.target.value?.trimStart()) {
      setFilterFocus(true);
    } else {
      setFilterFocus(false);
      setFilterPrincipleState({ page: 1, limit: 10 });
    }
    setFilterPrinciple(e.target.value?.trimStart());
  };

  const onKeyDownHandler = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e?.key === "Enter") {
      setFilterFocus(false);
      setFilterPrincipleState((prev) => ({
        ...prev,
        full_name: filterPrinciple,
        page: 1,
        limit: 10,
      }));
    }
  };
  useEffect(() => {
    if (filterPrinciple) {
      fetchFilterValues.cancel();
      fetchFilterValues("PRINCIPAL", "FILTERPRINCIPALS");
    }
    return () => {
      fetchFilterValues.cancel();
    };
  }, [filterPrinciple]);

  // -------------------------
  // 2. Main Category
  type FilterMainStateObj = {
    full_name?: string;
    limit: number;
    page: number;
  };
  const [filterMainState, setFilterMainState] = useState<FilterMainStateObj>({
    full_name: "",
    limit: 10,
    page: 1,
  });
  const [filtersearchMains, setFilterSearchMains] = useState<filterPrincipal[]>(
    []
  );
  const [filterMains, setFilterMains] = useState<filterPrincipal[]>([]);
  const [selectedMains, setSelectedMains] = useState<Set<string>>(new Set([]));
  const [filterMain, setFilterMain] = useState<string>("");
  const [FilterMainFocus, setFilterMainFocus] = useState<boolean>(false);
  const [selectedMainsValue, setSelectedMainsValue] =
    useState<string>("Search Value");

  const onMainCatInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value?.trimStart()) {
      setFilterMainFocus(true);
    } else {
      setFilterMainFocus(false);
      setFilterMainState({ page: 1, limit: 10 });
    }
    setFilterMain(e.target.value?.trimStart());
  };

  const onKeyDownMainCatHandler = (
    e: React.KeyboardEvent<HTMLInputElement>
  ): void => {
    if (e?.key === "Enter") {
      setFilterMainFocus(false);
      setFilterMainState((prev) => ({
        ...prev,
        full_name: filterMain,
        page: 1,
        limit: 10,
      }));
    }
  };

  const fetchFilterMainValues = debounce(async () => {
    const token = localStorage.getItem("token");

    // Ensure you use the correct base URL and filterPrinciple
    let api = `${BASE_URL}brand/getSuggestCategories?main_category=${filterMain}&brand_id=${selectedBrandId}&type=MAIN`;

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      const result = await axios.get(api, { headers });
      const { principal_category_array } = result?.data?.data;
      type main = {
        main_category_id: string;
        main_category: string;
      };
      const converted_arr = principal_category_array.map((item: main) => ({
        id: item?.main_category_id,
        label: item?.main_category,
      }));
      setFilterMains(converted_arr);
    } catch (error) {
      appError(error);
    } finally {
      // Optionally handle any cleanup or final actions
    }
  }, 500);

  useEffect(() => {
    if (filterMain) {
      fetchFilterMainValues.cancel();
      fetchFilterMainValues();
    }
    return () => {
      fetchFilterMainValues.cancel();
    };
  }, [filterMain]);

  // 3. Category
  type FilterCatStateObj = {
    full_name?: string;
    limit: number;
    page: number;
  };
  const [filterCatState, setFilterCatState] = useState<FilterCatStateObj>({
    full_name: "",
    limit: 10,
    page: 1,
  });
  const [filtersearchCats, setFilterSearchCats] = useState<filterPrincipal[]>(
    []
  );
  const [filterCats, setFilterCats] = useState<filterPrincipal[]>([]);
  const [selectedCats, setSelectedCats] = useState<Set<string>>(new Set([]));
  const [filterCat, setFilterCat] = useState<string>("");
  const [FilterCatFocus, setFilterCatFocus] = useState<boolean>(false);
  const [selectedCatsValue, setSelectedCatsValue] =
    useState<string>("Search Value");

  const onCatInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value?.trimStart()) {
      setFilterCatFocus(true);
    } else {
      setFilterCatFocus(false);
      setFilterCatState({ page: 1, limit: 10 });
    }
    setFilterCat(e.target.value?.trimStart());
  };

  const onKeyDownCatHandler = (
    e: React.KeyboardEvent<HTMLInputElement>
  ): void => {
    if (e?.key === "Enter") {
      setFilterCatFocus(false);
      setFilterCatState((prev) => ({
        ...prev,
        full_name: filterCat,
        page: 1,
        limit: 10,
      }));
    }
  };

  const fetchFilterCatValues = debounce(async () => {
    const token = localStorage.getItem("token");

    // Ensure you use the correct base URL and filterPrinciple
    let api = `${BASE_URL}brand/getSuggestCategories?category=${filterCat}&brand_id=${selectedBrandId}&type=CATEGORY`;

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      const result = await axios.get(api, { headers });
      const { principal_category_array } = result?.data?.data;
      type category = {
        category_id: string;
        category: string;
      };
      const converted_arr = principal_category_array.map((item: category) => ({
        id: item?.category_id,
        label: item?.category,
      }));
      setFilterCats(converted_arr);
    } catch (error) {
      appError(error);
    } finally {
      // Optionally handle any cleanup or final actions
    }
  }, 500);

  useEffect(() => {
    if (filterCat) {
      fetchFilterCatValues.cancel();
      fetchFilterCatValues();
    }
    return () => {
      fetchFilterCatValues.cancel();
    };
  }, [filterCat]);

  // 4. Filter Sub Category
  type FilterSubCatStateObj = {
    full_name?: string;
    limit: number;
    page: number;
  };
  const [filterSubCatState, setFilterSubCatState] =
    useState<FilterSubCatStateObj>({
      full_name: "",
      limit: 10,
      page: 1,
    });
  const [filtersearchSubCats, setFilterSearchSubCats] = useState<
    filterPrincipal[]
  >([]);
  const [filterSubCats, setFilterSubCats] = useState<filterPrincipal[]>([]);
  const [selectedSubCats, setSelectedSubCats] = useState<Set<string>>(
    new Set([])
  );
  const [filterSubCat, setFilterSubCat] = useState<string>("");
  const [FilterSubCatFocus, setFilterSubCatFocus] = useState<boolean>(false);
  const [selectedSubCatsValue, setSelectedSubCatsValue] =
    useState<string>("Search Value");

  const onSubCatInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value?.trimStart()) {
      setFilterSubCatFocus(true);
    } else {
      setFilterSubCatFocus(false);
      setFilterSubCatState({ page: 1, limit: 10 });
    }
    setFilterSubCat(e.target.value?.trimStart());
  };

  const onKeyDownSubCatHandler = (
    e: React.KeyboardEvent<HTMLInputElement>
  ): void => {
    if (e?.key === "Enter") {
      setFilterSubCatFocus(false);
      setFilterSubCatState((prev) => ({
        ...prev,
        full_name: filterSubCat,
        page: 1,
        limit: 10,
      }));
    }
  };

  const fetchFilterSubCatValues = debounce(async () => {
    const token = localStorage.getItem("token");

    // Ensure you use the correct base URL and filterPrinciple
    let api = `${BASE_URL}brand/getSuggestCategories?sub_category=${filterSubCat}&brand_id=${selectedBrandId}&type=SUB`;

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      const result = await axios.get(api, { headers });
      const { principal_category_array } = result?.data?.data;
      type sub_category = {
        sub_category_id: string;
        sub_category: string;
      };
      const converted_arr = principal_category_array.map(
        (item: sub_category) => ({
          id: item?.sub_category_id,
          label: item?.sub_category,
        })
      );
      setFilterSubCats(converted_arr);
    } catch (error) {
      appError(error);
    } finally {
      // Optionally handle any cleanup or final actions
    }
  }, 500);

  useEffect(() => {
    if (filterSubCat) {
      fetchFilterSubCatValues.cancel();
      fetchFilterSubCatValues();
    }
    return () => {
      fetchFilterSubCatValues.cancel();
    };
  }, [filterSubCat]);

  // ------------Edit Category
  type EditData = {
    principal_cat: string;
    main_cat: string;
    cat: string;
    sub_cat: string;
    principal_cat_id: string;
    main_cat_id: string;
    cat_id: string;
    sub_cat_id: string;
    cat_level: number;
  };
  const [editData, setEditData] = useState<EditData>({
    principal_cat: "",
    main_cat: "",
    cat: "",
    sub_cat: "",
    principal_cat_id: "",
    main_cat_id: "",
    cat_id: "",
    sub_cat_id: "",
    cat_level: 0,
  });

  const fetchkeywords = async (brand_Id: string, category_level: number) => {
    setDataFetchingState("LOADING");
    const token = localStorage.getItem("token");
    const {
      page,
      limit,
      principal_category,
      main_category,
      category,
      sub_category,
    } = filterState;

    let api = `${BASE_URL}brand/category?brand_id=${brand_Id}&page=${page}&limit=${limit}`;

    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await axios.get(api, {
        headers: headers,
        params: {
          cat_level: category_level,
          principal_category: "",
          main_category: "",
          category: "",
          sub_category: "",
        }, // Axios does not officially support body for GET, but this is how it would work if supported
      });
      const { category_array, total_records, total_limit_records } =
        result?.data?.data;
      if (total_records === 0) {
        setDataFetchingState("EMPTY");
      } else {
        setCategories_arr(category_array);
        setTotalRows(total_records);
        setDataFetchingState("SUCCESS");
      }
    } catch (error) {
      appError(error);
    } finally {
    }
  };

  const saveAddCategory = async (data: CreateState) => {
    setSaveLoading(true);
    const api = `${BASE_URL}brand/category?brand_id=${selectedBrandId}`;
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await axios.post(api, data, {
        headers: headers,
      });
      const { message } = result?.data?.data;
      toast.success(message);
      setCreateState((prev) => ({
        ...prev,
        principal_id: "",
        main_cat_id: "",
        sub_cat_id: "",
        cat_id: "",
        principal_category: "",
        main_category: "",
        category: "",
        sub_category: "",
        status: "ACTIVE",
      }));
      setOtherName("");
      setSaveLoading(false);
    } catch (error) {
      appError(error);
    }
  };

  const replaceEmptyStringsWithNull = (data: CreateState) => {
    if (data.principal_id === "") {
      data.principal_id = null;
    }
    if (data.main_cat_id === "") {
      data.main_cat_id = null;
    }
    if (data.sub_cat_id === "") {
      data.sub_cat_id = null;
    }
    if (data.cat_id === "") {
      data.cat_id = null;
    }
    return data;
  };

  const saveAddCategoryHandler = () => {
    if (hierarchy_level === 4) {
      if (
        createState?.principal_id !== "" &&
        createState?.main_cat_id !== "" &&
        createState?.cat_id !== "" &&
        createState?.sub_cat_id !== ""
      ) {
        appError("Already Mapped");
        return;
      }
    } else if (hierarchy_level === 3) {
      if (
        createState?.main_cat_id !== "" &&
        createState?.cat_id !== "" &&
        createState?.sub_cat_id !== ""
      ) {
        appError("Already Mapped");
        return;
      }
    } else if (hierarchy_level === 2) {
      if (createState?.cat_id !== "" && createState?.sub_cat_id !== "") {
        appError("Already Mapped");
        return;
      }
    }
    let schema = Joi.object({
      status: Joi.string().valid("ACTIVE").required(),
      created_by: Joi.string()
        .guid({ version: "uuidv4" })
        .allow("")
        .required()
        .optional(),
      cat_level: Joi.number().valid(4, 3, 2).required(),
    });
    if (hierarchy_level === 4) {
      if (othername === "PRINCIPAL" && createState?.principal_id === "") {
        schema = schema.concat(
          Joi.object({
            principal_category: Joi.string().required(),
            main_category: Joi.string().required(),
            category: Joi.string().required(),
            sub_category: Joi.string().required(),
            principal_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            main_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            sub_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
          })
        );
      } else if (
        othername === "MAIN" &&
        createState?.principal_id !== "" &&
        createState?.main_cat_id === ""
      ) {
        schema = schema.concat(
          Joi.object({
            principal_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .required(),
            main_category: Joi.string().required(),
            category: Joi.string().required(),
            sub_category: Joi.string().required(),
            main_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            sub_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            principal_category: Joi.string().allow("").optional(),
          })
        );
      } else if (
        othername === "CATEGORY" &&
        createState?.principal_id !== "" &&
        createState?.main_cat_id !== "" &&
        createState?.cat_id === ""
      ) {
        schema = schema.concat(
          Joi.object({
            principal_id: Joi.string().guid({ version: "uuidv4" }).allow(""),
            main_cat_id: Joi.string().guid({ version: "uuidv4" }).allow(""),
            category: Joi.string().required(),
            sub_category: Joi.string().required(),
            cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            sub_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            principal_category: Joi.string().allow("").optional(),
            main_category: Joi.string().allow("").optional(),
          })
        );
      } else if (
        othername === "SUB" &&
        createState?.principal_id !== "" &&
        createState?.main_cat_id !== "" &&
        createState?.cat_id !== "" &&
        createState?.sub_cat_id === ""
      ) {
        schema = schema.concat(
          Joi.object({
            principal_id: Joi.string().guid({ version: "uuidv4" }).allow(""),
            main_cat_id: Joi.string().guid({ version: "uuidv4" }).allow(""),
            cat_id: Joi.string().guid({ version: "uuidv4" }).allow(""),
            sub_category: Joi.string().required(),
            sub_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            principal_category: Joi.string().allow("").optional(),
            main_category: Joi.string().allow("").optional(),
            category: Joi.string().allow("").optional(),
          })
        );
      } else if (
        othername === "" &&
        createState?.principal_id !== "" &&
        createState?.main_cat_id !== "" &&
        createState?.cat_id !== "" &&
        createState?.sub_cat_id !== ""
      ) {
        schema = schema.concat(
          Joi.object({
            principal_id: Joi.string().guid({ version: "uuidv4" }),
            main_cat_id: Joi.string().guid({ version: "uuidv4" }),
            sub_cat_id: Joi.string().guid({ version: "uuidv4" }),
            cat_id: Joi.string().guid({ version: "uuidv4" }),
            principal_category: Joi.string().allow("").optional(),
            main_category: Joi.string().allow("").optional(),
            category: Joi.string().allow("").optional(),
            sub_category: Joi.string().allow("").optional(),
          })
        );
      }
    } else if (hierarchy_level === 3) {
      if (othername === "MAIN" && createState?.main_cat_id === "") {
        schema = schema.concat(
          Joi.object({
            main_category: Joi.string().required(),
            category: Joi.string().required(),
            sub_category: Joi.string().required(),
            principal_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            main_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            sub_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            principal_category: Joi.string().allow("").optional(),
          })
        );
      } else if (
        othername === "CATEGORY" &&
        createState?.main_cat_id !== "" &&
        createState?.cat_id === ""
      ) {
        schema = schema.concat(
          Joi.object({
            main_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .required(),
            category: Joi.string().required(),
            sub_category: Joi.string().required(),
            principal_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            sub_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            principal_category: Joi.string().allow("").optional(),
            main_category: Joi.string().allow("").optional(),
          })
        );
      } else if (
        othername === "SUB" &&
        createState?.main_cat_id !== "" &&
        createState?.cat_id !== "" &&
        createState?.sub_cat_id === ""
      ) {
        schema = schema.concat(
          Joi.object({
            main_cat_id: Joi.string().guid({ version: "uuidv4" }).allow(""),
            cat_id: Joi.string().guid({ version: "uuidv4" }).allow(""),
            sub_category: Joi.string().required(),
            principal_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            sub_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            principal_category: Joi.string().allow("").optional(),
            main_category: Joi.string().allow("").optional(),
            category: Joi.string().allow("").optional(),
          })
        );
      } else if (
        othername === "" &&
        createState?.main_cat_id !== "" &&
        createState?.cat_id !== "" &&
        createState?.sub_cat_id !== ""
      ) {
        schema = schema.concat(
          Joi.object({
            main_cat_id: Joi.string().guid({ version: "uuidv4" }),
            sub_cat_id: Joi.string().guid({ version: "uuidv4" }),
            cat_id: Joi.string().guid({ version: "uuidv4" }),
            principal_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            principal_category: Joi.string().allow("").optional(),
            main_category: Joi.string().allow("").optional(),
            category: Joi.string().allow("").optional(),
            sub_category: Joi.string().allow("").optional(),
          })
        );
      }
    } else {
      if (othername === "CATEGORY" && createState?.cat_id === "") {
        schema = schema.concat(
          Joi.object({
            category: Joi.string().required(),
            sub_category: Joi.string().required(),
            principal_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            main_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            sub_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            principal_category: Joi.string().allow("").optional(),
            main_category: Joi.string().allow("").optional(),
          })
        );
      } else if (
        othername === "SUB" &&
        createState?.cat_id !== "" &&
        createState?.sub_cat_id === ""
      ) {
        schema = schema.concat(
          Joi.object({
            cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .required(),
            sub_category: Joi.string().required(),
            principal_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            main_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            sub_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            principal_category: Joi.string().allow("").optional(),
            main_category: Joi.string().allow("").optional(),
            category: Joi.string().allow("").optional(),
          })
        );
      } else if (
        othername === "" &&
        createState?.cat_id !== "" &&
        createState?.sub_cat_id !== ""
      ) {
        schema = schema.concat(
          Joi.object({
            sub_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .required(),
            cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .required(),
            principal_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            main_cat_id: Joi.string()
              .guid({ version: "uuidv4" })
              .allow("")
              .optional(),
            principal_category: Joi.string().allow("").optional(),
            main_category: Joi.string().allow("").optional(),
            category: Joi.string().allow("").optional(),
            sub_category: Joi.string().allow("").optional(),
          })
        );
      }
    }
    const validate = schema.validate(createState);
    if (validate.error) {
      appError(validate?.error?.toString());
      return;
    }
    const dummydata = replaceEmptyStringsWithNull({ ...createState });
    saveAddCategory(dummydata);
    setAddKeywordToggle(false);
  };

  const onSelectChangeHandler = (name: string, value: string) => {
    setCreateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const updateCategory = async () => {
    setEditLoading(true);
    const api = `${BASE_URL}brand/category?brand_id=${selectedBrandId}`;
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await axios.put(api, editData, {
        headers: headers,
      });
      const { message } = result?.data?.data;
      toast.success(message);
      setEditData({
        principal_cat: "",
        main_cat: "",
        cat: "",
        sub_cat: "",
        principal_cat_id: "",
        main_cat_id: "",
        cat_id: "",
        sub_cat_id: "",
        cat_level: hierarchy_level,
      });
      setEditToggle(false);
      setEditLoading(false);
    } catch (error) {
      appError(error);
    }
  };

  const UpdateCategoryHandler = () => {
    let schema = Joi.object({
      updated_user_id: Joi.string()
        .guid({ version: "uuidv4" })
        .allow("")
        .required()
        .optional(),
      cat_level: Joi.number().valid(4, 3, 2).required(),
      cat_id: Joi.string().guid({ version: "uuidv4" }).required(),
      sub_cat_id: Joi.string().guid({ version: "uuidv4" }).required(),
      cat: Joi.string().min(3).required(),
      sub_cat: Joi.string().min(3).required(),
    });
    if (hierarchy_level === 4) {
      schema = schema.concat(
        Joi.object({
          principal_cat: Joi.string().min(3).required(),
          main_cat: Joi.string().min(3).required(),
          principal_cat_id: Joi.string().guid({ version: "uuidv4" }).required(),
          main_cat_id: Joi.string().guid({ version: "uuidv4" }).required(),
        })
      );
    } else if (hierarchy_level === 3) {
      schema = schema.concat(
        Joi.object({
          main_cat: Joi.string().min(3).required(),
          main_cat_id: Joi.string().guid({ version: "uuidv4" }).required(),
        })
      );
    }
    const validate = schema.validate(editData);
    if (validate.error) {
      appError(validate?.error?.toString());
      return;
    }
    updateCategory();
  };

  const fetchFilterData = async (BrandId: string, type: string) => {
    if (!selectedBrandId) {
      console.error("selectedBrandId is undefined");
      return; // Exit the function if the ID is missing
    }
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    let api = `${BASE_URL}brand/category/filterStateData?brand_id=${BrandId}`;
    try {
      if (type === "PRINCIPAL") {
        api = `${api}&data_name=PRINCIPAL&principal_id`;
      } else if (type === "MAIN") {
        api = `${api}&data_name=MAIN&main_cat_id`;
      } else if (type === "CATEGORY") {
        api = `${api}&data_name=CATEGORY&cat_id`;
      } else if (type === "SUB") {
        api = `${api}&data_name=SUB`;
      }
      const result = await axios.get(api, {
        headers: headers,
      });
      const { total_records, category_array } = result?.data?.data;
      if (type === "PRINCIPAL") {
        setFilterSearchPrinciples(
          category_array.map((m: SuggestPrincipal) => ({
            id: m?.principal_category_id,
            label: m?.principal_category,
          }))
        );
      } else if (type === "MAIN") {
        setFilterSearchMains(
          category_array.map((m: SuggestMain) => ({
            id: m?.main_category_id,
            label: m?.main_category,
          }))
        );
      } else if (type === "CATEGORY") {
        setFilterSearchCats(
          category_array.map((m: SuggestCategory) => ({
            id: m?.category_id,
            label: m?.category,
          }))
        );
      } else if (type === "SUB") {
        setFilterSearchSubCats(
          category_array.map((m: SuggestSubCategory) => ({
            id: m?.sub_category_id,
            label: m?.sub_category,
          }))
        );
      }
    } catch (error) {
      appError(error);
    }
  };

  const onFilterHandler = () => {
    setFilterToggle(true);
  };

  const filterhandler = async () => {
    let dataobj = {
      brand_id: selectedBrandId,
      cat_level: hierarchy_level,
      principal_category:
        selectedPriciplesValue === "Search Value" ? "" : selectedPriciplesValue,
      main_category:
        selectedMainsValue === "Search Value" ? "" : selectedMainsValue,
      category: selectedCatsValue === "Search Value" ? "" : selectedCatsValue,
      sub_category:
        selectedSubCatsValue === "Search Value" ? "" : selectedSubCatsValue,
    };
    let schema = Joi.object({
      brand_id: Joi.string().required(),

      cat_level: Joi.number().valid(4, 3, 2).required(),
    }).unknown();
    if (hierarchy_level === 4) {
      schema = schema.concat(
        Joi.object({
          principal_category: Joi.string().required(),
          main_category: Joi.string().required(),
          category: Joi.string().required(),
          sub_category: Joi.string().required(),
        })
      );
    } else if (hierarchy_level === 3) {
      schema = schema.concat(
        Joi.object({
          main_category: Joi.string().required(),
          category: Joi.string().required(),
          sub_category: Joi.string().required(),
        })
      );
    }
    else if(hierarchy_level === 2){
      schema = schema.concat(
        Joi.object({
          category: Joi.string().required(),
          sub_category: Joi.string().required(),
        })
      );
    }
    const validate = schema.validate(dataobj);
    if (validate.error) {
      appError(validate?.error?.toString());
      return;
    }
    setDataFetchingState("LOADING");
    setFilterLoading(true);
    const token = localStorage.getItem("token");
    const { page, limit } = filterState;
    const {
      cat_level,
      principal_category,
      main_category,
      category,
      sub_category,
    } = dataobj;
    let api = `${BASE_URL}brand/category?brand_id=${selectedBrandId}&page=${page}&limit=${limit}`;

    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await axios.get(api, {
        headers: headers,
        params: {
          cat_level,
          principal_category,
          main_category,
          category,
          sub_category,
        }, // Axios does not officially support body for GET, but this is how it would work if supported
      });
      const { category_array, total_records, total_limit_records } =
        result?.data?.data;
      if (total_records === 0) {
        setTotalRows(total_records);
        setDataFetchingState("EMPTY");
      } else {
        setCategories_arr(category_array);
        setTotalRows(total_records);
        setDataFetchingState("SUCCESS");
      }
    } catch (error) {
      appError(error);
    } finally {
      setFilterToggle(false);
      setFilterLoading(false);
    }
  };

  useEffect(() => {
    if (selectedBrandId) {
      fetchkeywords(selectedBrandId, hierarchy_level);
    }
  }, [filterState.page, filterState.limit]);

  useEffect(() => {
    setCreateState((prev) => ({
      ...prev,
      ["cat_level"]: hierarchy_level,
    }));
    setEditData((prev) => ({
      ...prev,
      ["cat_level"]: hierarchy_level,
    }));
    if (selectedBrandId) {
      if (hierarchy_level) {
        fetchkeywords(selectedBrandId, hierarchy_level);
      }
      fetchFilterData(selectedBrandId, "PRINCIPAL");
      fetchFilterData(selectedBrandId, "MAIN");
      fetchFilterData(selectedBrandId, "CATEGORY");
      fetchFilterData(selectedBrandId, "SUB");
    }
  }, [selectedBrandId]);

  const fetchSuggestValues = async (brand_Id: string, data_name: string) => {
    const token = localStorage.getItem("token");
    const { principal_id, main_cat_id, cat_id } = createState;
    let api = `${BASE_URL}brand/category/filterStateData?brand_id=${brand_Id}`;

    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await axios.get(api, {
        headers: headers,
        params: { data_name, principal_id, main_cat_id, cat_id }, // Axios does not officially support body for GET, but this is how it would work if supported
      });
      const { category_array } = result?.data?.data;
      if (data_name === "PRINCIPAL") {
        if (principal_id !== "") {
          setSuggestMains(category_array);
        } else {
          setSuggestPrincipals(category_array);
        }
      } else if (data_name === "MAIN") {
        if (main_cat_id !== "") {
          setSuggestCategorys(category_array);
        } else {
          setSuggestMains(category_array);
        }
      } else if (data_name === "CATEGORY") {
        if (cat_id !== "") {
          setSuggestSubCategorys(category_array);
        } else {
          setSuggestCategorys(category_array);
        }
      } else if (data_name === "SUB") {
        setSuggestSubCategorys(category_array);
      }
    } catch (error) {
      appError(error);
    } finally {
    }
  };

  useEffect(() => {
    if (createState?.cat_id) {
      fetchSuggestValues(selectedBrandId, "CATEGORY");
    } else if (createState?.main_cat_id) {
      fetchSuggestValues(selectedBrandId, "MAIN");
    } else if (addKeywordToggle && createState?.principal_id) {
      fetchSuggestValues(selectedBrandId, "PRINCIPAL");
    }
  }, [
    createState?.principal_id,
    createState?.main_cat_id,
    createState?.cat_id,
  ]);

  return (
    <>
      <div className="px-10 pt-6">
        <div
          className="flex flex-row justify-between items-center px-6"
          style={{
            height: 96,
            borderRadius: 8,
            backgroundColor: PRIMARY.P_Purple50,
          }}
        >
          <div>
            <div
              className="mb-1"
              style={{
                fontSize: 16,
                color: BLACK.B_100,
                fontWeight: 600,
                lineHeight: "24px",
              }}
            >
              Add New Categories
            </div>
            <div
              style={{
                fontSize: 12,
                fontWeight: 400,
                lineHeight: "18px",
                color: BLACK.B_40,
              }}
            >
              {" "}
              Expand your categories to refine data.
            </div>
          </div>

          <Button
            // loading={loading}
            onClick={() => {
              if (hierarchy_level === 4) {
                fetchSuggestValues(selectedBrandId, "PRINCIPAL");
              } else if (hierarchy_level === 3) {
                fetchSuggestValues(selectedBrandId, "MAIN");
              } else {
                fetchSuggestValues(selectedBrandId, "CATEGORY");
              }
              setAddKeywordToggle(true);
            }}
            startDecorator={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M9.16663 10.8333H4.99996C4.76385 10.8333 4.56593 10.7535 4.40621 10.5937C4.24649 10.434 4.16663 10.2361 4.16663 9.99999C4.16663 9.76388 4.24649 9.56596 4.40621 9.40624C4.56593 9.24652 4.76385 9.16666 4.99996 9.16666H9.16663V4.99999C9.16663 4.76388 9.24649 4.56596 9.40621 4.40624C9.56593 4.24652 9.76385 4.16666 9.99996 4.16666C10.2361 4.16666 10.434 4.24652 10.5937 4.40624C10.7534 4.56596 10.8333 4.76388 10.8333 4.99999V9.16666H15C15.2361 9.16666 15.434 9.24652 15.5937 9.40624C15.7534 9.56596 15.8333 9.76388 15.8333 9.99999C15.8333 10.2361 15.7534 10.434 15.5937 10.5937C15.434 10.7535 15.2361 10.8333 15 10.8333H10.8333V15C10.8333 15.2361 10.7534 15.434 10.5937 15.5937C10.434 15.7535 10.2361 15.8333 9.99996 15.8333C9.76385 15.8333 9.56593 15.7535 9.40621 15.5937C9.24649 15.434 9.16663 15.2361 9.16663 15V10.8333Z"
                  fill="white"
                />
              </svg>
            }
            sx={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "20px",
              height: "48px",
              width: "200px",
              backgroundColor: PRIMARY.P_BLue,
            }}
          >
            Add New Categories
          </Button>
        </div>

        <div className="flex mt-6 justify-between items-center self-stretch">
          {/**Search container */}
          <div className="flex h-[46px] flex-col items-start gap-1 ">
            <div
              className="self-stretch"
              style={{
                color: BLACK.B_100,
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "24px",
              }}
            >
              Explore Categories
            </div>
            <div
              className="self-stretch"
              style={{
                color: BLACK.B_40,
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "18px",
              }}
            >
              Discover different types of categories to organize and analyze
              your data.
            </div>
          </div>

          <div
            className="flex h-10 px-4 py-2 justify-center gap-2 rounded-[8px] cursor-pointer"
            style={{ border: `1px solid ${BLACK.B_5}` }}
            onClick={onFilterHandler}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10ZM18.125 5.625H1.875C1.70924 5.625 1.55027 5.69085 1.43306 5.80806C1.31585 5.92527 1.25 6.08424 1.25 6.25C1.25 6.41576 1.31585 6.57473 1.43306 6.69194C1.55027 6.80915 1.70924 6.875 1.875 6.875H18.125C18.2908 6.875 18.4497 6.80915 18.5669 6.69194C18.6842 6.57473 18.75 6.41576 18.75 6.25C18.75 6.08424 18.6842 5.92527 18.5669 5.80806C18.4497 5.69085 18.2908 5.625 18.125 5.625ZM11.875 13.125H8.125C7.95924 13.125 7.80027 13.1908 7.68306 13.3081C7.56585 13.4253 7.5 13.5842 7.5 13.75C7.5 13.9158 7.56585 14.0747 7.68306 14.1919C7.80027 14.3092 7.95924 14.375 8.125 14.375H11.875C12.0408 14.375 12.1997 14.3092 12.3169 14.1919C12.4342 14.0747 12.5 13.9158 12.5 13.75C12.5 13.5842 12.4342 13.4253 12.3169 13.3081C12.1997 13.1908 12.0408 13.125 11.875 13.125Z"
                fill="#1C1C1C"
              />
            </svg>
            <div
              style={{
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "20px",
                color: BLACK.B_100,
              }}
            >
              Filter
            </div>
          </div>
        </div>

        <div
          className="mt-6"
          style={{
            height: "calc(100vh - 376px)",
            borderRadius: 12,
            boxShadow: "0px 4px 10px 4px rgba(130, 130, 130, 0.05",
          }}
        >
          {hierarchy_level === 4 && (
            <div
              className="flex items-center w-full"
              style={{
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                height: 56,
                fontSize: 14,
                fontWeight: 700,
                lineHeight: "20px",
                backgroundColor: PRIMARY.P_Purple50,
              }}
            >
              <div className="p-4" style={{ width: "24%" }}>
                Principle Category
              </div>

              <div className="p-4" style={{ width: "24%" }}>
                Main Category
              </div>

              <div className="p-4" style={{ width: "24%" }}>
                Category
              </div>
              <div className="p-4" style={{ width: "24%" }}>
                Sub-Category
              </div>
              <div className="p-4 mr-4" style={{ width: "4%" }}>
                Edit
              </div>
            </div>
          )}
          {hierarchy_level === 3 && (
            <div
              className="flex items-center w-full"
              style={{
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                height: 56,
                fontSize: 14,
                fontWeight: 700,
                lineHeight: "20px",
                backgroundColor: PRIMARY.P_Purple50,
              }}
            >
              <div className="p-4" style={{ width: "32%" }}>
                Main Category
              </div>

              <div className="p-4" style={{ width: "32%" }}>
                Category
              </div>
              <div className="p-4" style={{ width: "32%" }}>
                Sub-Category
              </div>
              <div className="p-4 mr-4" style={{ width: "4%" }}>
                Edit
              </div>
            </div>
          )}
          {hierarchy_level === 2 && (
            <div
              className="flex items-center w-full"
              style={{
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                height: 56,
                fontSize: 14,
                fontWeight: 700,
                lineHeight: "20px",
                backgroundColor: PRIMARY.P_Purple50,
              }}
            >
              <div className="p-4" style={{ width: "48%" }}>
                Category
              </div>
              <div className="p-4" style={{ width: "48%" }}>
                Sub-Category
              </div>
              <div className="p-4 mr-4" style={{ width: "4%" }}>
                Edit
              </div>
            </div>
          )}

          {dataFetchingState === "LOADING" && (
            <div
              className="flex justify-center items-center"
              style={{
                // position: "absolute",
                height: "calc(100vh - 486px)",
                width: "calc(100% - 80px)",
              }}
            >
              <CircularProgress />
            </div>
          )}

          {dataFetchingState === "EMPTY" && (
            <div
              className="flex flex-col justify-center items-center py-6 self-stretch"
              style={{
                height: "calc(100vh - 486px)",
                // width: "calc(100% - 80px)",
              }}
            >
              <img
                height={220}
                width={220}
                className="shrink-0"
                src={`${process.env.PUBLIC_URL}/ic-content.png`}
                alt="Empty"
              />
              <div
                className="self-stretch"
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  color: "#9D9D9D",
                }}
              >
                No results found. Please choose another filter.
              </div>
            </div>
          )}

          {dataFetchingState === "SUCCESS" && (
            <div
              style={{ height: "calc(100vh - 486px)" }}
              className="overflow-y-auto"
            >
              {categories_arr.length > 0 &&
                categories_arr?.map((category) => {
                  return (
                    <>
                      {hierarchy_level === 4 ? (
                        <div
                          className="flex items-center w-full"
                          key={category?.sub_category_id}
                          style={{
                            height: 52,
                            borderBottom: `1px solid ${BLACK.B_5}`,
                            color: BLACK.B_80,
                          }}
                        >
                          <div
                            className="flex p-4 items-center self-stretch gap-2"
                            style={{ width: "24%" }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                fontStyle: "normal",
                                lineHeight: "18px",
                                color: BLACK.B_80,
                              }}
                            >
                              {category?.principal_category}
                            </div>
                          </div>

                          <div
                            className="flex p-4 items-center self-stretch gap-2"
                            style={{ width: "24%" }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                fontStyle: "normal",
                                lineHeight: "18px",
                                color: BLACK.B_80,
                              }}
                            >
                              {category?.main_category}
                            </div>
                          </div>

                          <div
                            className="flex p-4 items-center self-stretch gap-2"
                            style={{ width: "24%" }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                fontStyle: "normal",
                                lineHeight: "18px",
                                color: BLACK.B_80,
                              }}
                            >
                              {category?.category}
                            </div>
                          </div>

                          <div
                            className="flex p-4 items-center self-stretch gap-2"
                            style={{ width: "24%" }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                fontStyle: "normal",
                                lineHeight: "18px",
                                color: BLACK.B_80,
                              }}
                            >
                              {category?.sub_category}
                            </div>
                          </div>

                          <div
                            className="flex p-4 justify-center items-center gap-[4px] self-stretch cursor-pointer"
                            style={{ width: "4%" }}
                            onClick={() => {
                              setEditData((prev) => ({
                                ...prev,
                                ["principal_cat"]: category?.principal_category,
                                ["principal_cat_id"]:
                                  category?.principal_category_id,
                                ["main_cat"]: category?.main_category,
                                ["main_cat_id"]: category?.main_category_id,
                                ["cat"]: category?.category,
                                ["cat_id"]: category?.category_id,
                                ["sub_cat"]: category?.sub_category,
                                ["sub_cat_id"]: category?.sub_category_id,
                              }));
                              setEditToggle(true);
                              // fetchIds();
                            }}
                            // onClick={() => archiveIdSave(keyword?.targeting_id)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM3.33333 17.5C3.09722 17.5 2.89931 17.4201 2.73958 17.2604C2.57986 17.1007 2.5 16.9028 2.5 16.6667V14.6458C2.5 14.4236 2.54167 14.2118 2.625 14.0104C2.70833 13.809 2.82639 13.6319 2.97917 13.4792L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.52083 17.0208C6.36806 17.1736 6.19097 17.2917 5.98958 17.375C5.78819 17.4583 5.57639 17.5 5.35417 17.5H3.33333ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                                fill="#1C1C1C"
                                fill-opacity="0.8"
                              />
                            </svg>
                          </div>
                        </div>
                      ) : hierarchy_level === 3 ? (
                        <div
                          className="flex items-center w-full"
                          key={category?.sub_category_id}
                          style={{
                            height: 52,
                            borderBottom: `1px solid ${BLACK.B_5}`,
                            color: BLACK.B_80,
                          }}
                        >
                          <div
                            className="flex p-4 items-center self-stretch gap-2"
                            style={{ width: "32%" }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                fontStyle: "normal",
                                lineHeight: "18px",
                                color: BLACK.B_80,
                              }}
                            >
                              {category?.main_category}
                            </div>
                          </div>

                          <div
                            className="flex p-4 items-center self-stretch gap-2"
                            style={{ width: "32%" }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                fontStyle: "normal",
                                lineHeight: "18px",
                                color: BLACK.B_80,
                              }}
                            >
                              {category?.category}
                            </div>
                          </div>

                          <div
                            className="flex p-4 items-center self-stretch gap-2"
                            style={{ width: "32%" }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                fontStyle: "normal",
                                lineHeight: "18px",
                                color: BLACK.B_80,
                              }}
                            >
                              {category?.sub_category}
                            </div>
                          </div>

                          <div
                            className="flex p-4 justify-center items-center gap-[4px] self-stretch cursor-pointer"
                            style={{ width: "4%" }}
                            onClick={() => {
                              setEditData((prev) => ({
                                ...prev,
                                ["main_cat"]: category?.main_category,
                                ["main_cat_id"]: category?.main_category_id,
                                ["cat"]: category?.category,
                                ["cat_id"]: category?.category_id,
                                ["sub_cat"]: category?.sub_category,
                                ["sub_cat_id"]: category?.sub_category_id,
                              }));
                              setEditToggle(true);
                              // fetchIds();
                            }}
                            // onClick={() => archiveIdSave(keyword?.targeting_id)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM3.33333 17.5C3.09722 17.5 2.89931 17.4201 2.73958 17.2604C2.57986 17.1007 2.5 16.9028 2.5 16.6667V14.6458C2.5 14.4236 2.54167 14.2118 2.625 14.0104C2.70833 13.809 2.82639 13.6319 2.97917 13.4792L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.52083 17.0208C6.36806 17.1736 6.19097 17.2917 5.98958 17.375C5.78819 17.4583 5.57639 17.5 5.35417 17.5H3.33333ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                                fill="#1C1C1C"
                                fill-opacity="0.8"
                              />
                            </svg>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="flex items-center w-full"
                          key={category?.sub_category_id}
                          style={{
                            height: 52,
                            borderBottom: `1px solid ${BLACK.B_5}`,
                            color: BLACK.B_80,
                          }}
                        >
                          <div
                            className="flex p-4 items-center self-stretch gap-2"
                            style={{ width: "48%" }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                fontStyle: "normal",
                                lineHeight: "18px",
                                color: BLACK.B_80,
                              }}
                            >
                              {category?.category}
                            </div>
                          </div>

                          <div
                            className="flex p-4 items-center self-stretch gap-2"
                            style={{ width: "48%" }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                fontStyle: "normal",
                                lineHeight: "18px",
                                color: BLACK.B_80,
                              }}
                            >
                              {category?.sub_category}
                            </div>
                          </div>

                          <div
                            className="flex p-4 justify-center items-center gap-[4px] self-stretch cursor-pointer"
                            style={{ width: "4%" }}
                            onClick={() => {
                              setEditData((prev) => ({
                                ...prev,
                                ["cat"]: category?.category,
                                ["cat_id"]: category?.category_id,
                                ["sub_cat"]: category?.sub_category,
                                ["sub_cat_id"]: category?.sub_category_id,
                              }));
                              setEditToggle(true);
                              // fetchIds();
                            }}
                            // onClick={() => archiveIdSave(keyword?.targeting_id)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM3.33333 17.5C3.09722 17.5 2.89931 17.4201 2.73958 17.2604C2.57986 17.1007 2.5 16.9028 2.5 16.6667V14.6458C2.5 14.4236 2.54167 14.2118 2.625 14.0104C2.70833 13.809 2.82639 13.6319 2.97917 13.4792L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.52083 17.0208C6.36806 17.1736 6.19097 17.2917 5.98958 17.375C5.78819 17.4583 5.57639 17.5 5.35417 17.5H3.33333ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                                fill="#1C1C1C"
                                fill-opacity="0.8"
                              />
                            </svg>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
            </div>
          )}

          <div
            className="flex justify-between items-center px-4"
            style={{
              borderTop: `1px solid ${BLACK.B_5}`,
              height: 60,
              borderBottomLeftRadius: 12,
              borderBottomRightRadius: 12,
            }}
          >
            <div className="flex items-center">
              <div
                className="mr-2"
                style={{ fontSize: 12, fontWeight: 400, lineHeight: "18px" }}
              >
                Rows per page:
              </div>
              <Select
                onChange={(e, limit) =>
                  setFilterState((prevState) => ({
                    ...prevState,
                    page: 1,
                    limit: limit ? limit : 0 * 1,
                  }))
                }
                // placeholder="Select State"
                name="status"
                value={filterState.limit}
                indicator={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.56251 12.0625L6.54167 9.04171C6.50001 9.00004 6.46876 8.9549 6.44792 8.90629C6.42709 8.85768 6.41667 8.8056 6.41667 8.75004C6.41667 8.63893 6.45487 8.54171 6.53126 8.45837C6.60764 8.37504 6.70834 8.33337 6.83334 8.33337H13.1667C13.2917 8.33337 13.3924 8.37504 13.4688 8.45837C13.5451 8.54171 13.5833 8.63893 13.5833 8.75004C13.5833 8.77782 13.5417 8.87504 13.4583 9.04171L10.4375 12.0625C10.3681 12.132 10.2986 12.1806 10.2292 12.2084C10.1597 12.2362 10.0833 12.25 10 12.25C9.91667 12.25 9.84028 12.2362 9.77084 12.2084C9.70139 12.1806 9.63195 12.132 9.56251 12.0625Z"
                      fill="#1C1C1C"
                      fill-opacity="0.8"
                    />
                  </svg>
                }
                sx={{
                  "--Input-focusedThickness": "0px",
                  width: "80px",
                  height: "28px",
                  backgroundColor: WHITE.W_100,
                  color: BLACK.B_80,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  border: `1px solid ${BLACK.B_10}`,
                  [`& .${selectClasses.indicator}`]: {
                    transition: "0.2s",
                    [`&.${selectClasses.expanded}`]: {
                      transform: "rotate(-180deg)",
                    },
                  },
                }}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={50}>50</Option>
              </Select>
            </div>
            {/* ---------------------Pagination Component------------------ */}
            <PaginationComponent
              page={filterState.page}
              limit={filterState.limit}
              totalRows={totalRows}
              onChange={(page) =>
                setFilterState((prevState) => ({ ...prevState, page }))
              }
            />
            {/* ---------------------Pagination Component------------------ */}
          </div>
        </div>
      </div>

      {/* Filter Drawer */}
      <Drawer key={"right"} anchor={"right"} open={filterToggle} size="md">
        <div
          className="flex p-6 items-start justify-between gap-10"
          style={{ height: 72, borderBottom: `1px solid ${BLACK.B_10}` }}
        >
          <div
            className="self-stretch"
            style={{
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              color: BLACK.B_100,
            }}
          >
            Filters
          </div>
          <div
            className="w-fit cursor-pointer"
            onClick={() => {
              // onClearFilterHandler();
              setSelectedPrinciplesValue("");
              setFilterPrinciple("");
              setSelectedMainsValue("");
              setFilterMain("");
              setSelectedCatsValue("");
              setFilterCat("");
              setSelectedSubCatsValue("");
              setFilterSubCat("");
              setFilterToggle(false);
              setSelectedPrinciples(new Set([]));
              setSelectedMains(new Set([]));
              setSelectedCats(new Set([]));
              setSelectedSubCats(new Set([]));
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                fill="#1C1C1C"
              />
            </svg>
          </div>
        </div>
        <DialogContent sx={{ paddingX: "24px", backgroundColor: WHITE.W_100 }}>
          {hierarchy_level === 4 && (
            <div className="pt-6">
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Principal Category
              </div>
              {/* New Component */}
              <MultiSelectSearchComponent
                InputChange={onPrincipleCatInputChange}
                InputValue={filterPrinciple}
                setInputValue={setFilterPrinciple}
                onKeyDownHandler={onKeyDownHandler}
                FilterFocus={FilterFocus}
                setFilterFocus={setFilterFocus}
                selectedPriciplesValue={selectedPriciplesValue}
                setSelectedPrinciples={setSelectedPrinciples}
                filterPrinciples={filterPrinciples}
                setFilterPrinciples={setFilterPrinciples}
                filtersearchPrinciples={filtersearchPrinciples}
                selectedPrinciples={selectedPrinciples}
                setSelectedValue={setSelectedPrinciplesValue}
              />
            </div>
          )}

          {(hierarchy_level === 4 || hierarchy_level === 3) && (
            <div className="pt-6">
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Main Category
              </div>
              {/* New Component */}
              <MultiSelectSearchComponent
                InputChange={onMainCatInputChange}
                InputValue={filterMain}
                setInputValue={setFilterMain}
                onKeyDownHandler={onKeyDownMainCatHandler}
                FilterFocus={FilterMainFocus}
                setFilterFocus={setFilterMainFocus}
                selectedPriciplesValue={selectedMainsValue}
                setSelectedPrinciples={setSelectedMains}
                filterPrinciples={filterMains}
                setFilterPrinciples={setFilterMains}
                filtersearchPrinciples={filtersearchMains}
                selectedPrinciples={selectedMains}
                // setSelectedPrinciples={setSelectedMains}
                setSelectedValue={setSelectedMainsValue}
              />
            </div>
          )}

          <div className="pt-6">
            <div
              className="mb-1"
              style={{
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                color: "#5B5B5B",
              }}
            >
              Category
            </div>
            {/* New Component */}
            <MultiSelectSearchComponent
              InputChange={onCatInputChange}
              InputValue={filterCat}
              setInputValue={setFilterCat}
              onKeyDownHandler={onKeyDownCatHandler}
              FilterFocus={FilterCatFocus}
              setFilterFocus={setFilterCatFocus}
              selectedPriciplesValue={selectedCatsValue}
              setSelectedPrinciples={setSelectedCats}
              filterPrinciples={filterCats}
              setFilterPrinciples={setFilterCats}
              filtersearchPrinciples={filtersearchCats}
              selectedPrinciples={selectedCats}
              setSelectedValue={setSelectedCatsValue}
            />
          </div>

          <div className="pt-6">
            <div
              className="mb-1"
              style={{
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                color: "#5B5B5B",
              }}
            >
              Sub_Category
            </div>
            {/* New Component */}
            <MultiSelectSearchComponent
              InputChange={onSubCatInputChange}
              InputValue={filterSubCat}
              setInputValue={setFilterSubCat}
              onKeyDownHandler={onKeyDownSubCatHandler}
              FilterFocus={FilterSubCatFocus}
              setFilterFocus={setFilterSubCatFocus}
              selectedPriciplesValue={selectedSubCatsValue}
              setSelectedPrinciples={setSelectedSubCats}
              filterPrinciples={filterSubCats}
              setFilterPrinciples={setFilterSubCats}
              filtersearchPrinciples={filtersearchSubCats}
              selectedPrinciples={selectedSubCats}
              setSelectedValue={setSelectedSubCatsValue}
            />
          </div>
        </DialogContent>
        <div
          className="flex items-center justify-center gap-5 px-6"
          style={{ height: 88, borderTop: `1px solid ${BLACK.B_10}` }}
        >
          <Button
            color="neutral"
            sx={{
              height: 40,
              // width: 150,
              width: "100%",
              fontSize: 14,
              fontWeight: 500,
              backgroundColor: BLACK.B_5,
              lineHeight: "20px",
              color: BLACK.B_100,
              ":hover": {
                backgroundColor: BLACK.B_20,
              },
            }}
            onClick={() => {
              setSelectedPrinciplesValue("");
              setFilterPrinciple("");
              setSelectedMainsValue("");
              setFilterMain("");
              setSelectedCatsValue("");
              setFilterCat("");
              setSelectedSubCatsValue("");
              setFilterSubCat("");
              setSelectedPrinciples(new Set([]));
              setSelectedMains(new Set([]));
              setSelectedCats(new Set([]));
              setSelectedSubCats(new Set([]));
            }}
          >
            Clear Filter
          </Button>
          <Button
            loading={filterloading}
            sx={{
              height: 40,
              // width: 150,
              width: "100%",
              fontSize: 14,
              fontWeight: 500,
              backgroundColor: PRIMARY.P_BLue,
              lineHeight: "20px",
              borderRadius: 8,
            }}
            onClick={filterhandler}
          >
            Save
          </Button>
        </div>
      </Drawer>

      {/* Add Drawer */}
      <Drawer key={"right"} anchor={"right"} open={addKeywordToggle} size="md">
        <div
          className="flex p-6 items-start justify-between gap-10"
          style={{
            height: 72,
            borderBottom: `1px solid ${BLACK.B_10}`,
            backgroundColor: WHITE.W_100,
          }}
        >
          <div
            className="self-stretch"
            style={{
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              color: BLACK.B_100,
            }}
          >
            Add Category
          </div>

          <div
            className="w-fit cursor-pointer"
            onClick={() => {
              setAddKeywordToggle(false);
              setCreateState((prev) => ({
                ...prev,
                sub_cat_id: "",
                main_cat_id: "",
                principal_id: "",
                cat_id: "",
                principal_category: "",
                main_category: "",
                category: "",
                sub_category: "",
              }));
              setOtherName("");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                fill="#1C1C1C"
              />
            </svg>
          </div>
        </div>

        {hierarchy_level === 4 && (
          <DialogContent
            sx={{
              paddingX: "24px",
              backgroundColor: WHITE.W_100,
            }}
          >
            {/* Principle Category */}

            <div
              className=" pt-6 flex flex-col "
              style={{ backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Principle Category
              </div>
              <Autocomplete
                value={
                  othername === "" ||
                  othername === "MAIN" ||
                  othername === "CATEGORY" ||
                  othername === "SUB"
                    ? createState?.principal_id
                      ? suggestPrincipals.find(
                          (p) =>
                            p.principal_category_id ===
                            createState?.principal_id
                        )
                      : { principal_category: "", principal_category_id: "" }
                    : {
                        principal_category: "Other",
                        principal_category_id: "",
                      }
                }
                placeholder="Search Value"
                options={
                  suggestPrincipals?.length
                    ? (suggestPrincipals as readonly any[])
                    : []
                }
                getOptionLabel={(option) => option.principal_category}
                onChange={(event, newValue) => {
                  // Check if newValue is null or undefined
                  if (newValue) {
                    if (newValue.principal_category_id) {
                      onSelectChangeHandler(
                        "principal_id",
                        newValue.principal_category_id
                      );
                      setOtherName("");
                    } else if (newValue.principal_category === "Other") {
                      setOtherName("PRINCIPAL");
                      onSelectChangeHandler("principal_id", "");
                    } else {
                      onSelectChangeHandler("principal_id", "");
                      setOtherName("");
                    }
                  } else {
                    // Handle case when newValue is null or undefined
                    onSelectChangeHandler("principal_id", "");
                    setOtherName("");
                    setCreateState((prev) => ({
                      ...prev,
                      principal_category: "",
                      main_category: "",
                      category: "",
                      sub_category: "",
                      main_cat_id: "",
                      cat_id: "",
                      sub_cat_id: "",
                    }));
                  }
                }}
                filterOptions={(options, state) => {
                  const { inputValue } = state;
                  let arr = [];
                  if (Array.isArray(options)) {
                    arr = options.filter((option) =>
                      option.principal_category
                        .toLowerCase()
                        .includes(inputValue?.toLowerCase())
                    );
                    if (arr.length === 0) {
                      arr.push({
                        principal_category: "Other",
                        principal_category_id: "" as UUID,
                      });
                    }
                  }
                  return arr;
                }}
                sx={{
                  width: "100%",
                  height: 52,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  borderRadius: 8,
                  "--Input-focusedThickness": "0px",
                  ":focus-within": {
                    border: `1px solid ${BLACK.B_10}`,
                  },
                  backgroundColor: WHITE.W_100,
                  color:
                    createState?.principal_id === "" && othername === ""
                      ? BLACK.B_40
                      : BLACK.B_100,
                  boxShadow: "none",
                  "&.Mui-disabled": {
                    bgcolor: BLACK.B_10,
                  },
                }}
              />
            </div>

            {othername === "PRINCIPAL" && (
              <div className="pt-6" style={{ backgroundColor: WHITE.W_100 }}>
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#5B5B5B",
                  }}
                >
                  Other Principle Category
                </div>
                <Input
                  placeholder="Add Other Principle Category"
                  sx={{
                    "--Input-focusedThickness": "0px",
                    // width: "340px",
                    height: "52px",
                    backgroundColor: WHITE.W_100,
                    border: `1px solid ${BLACK.B_10}`,
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    color:
                      createState && createState?.principal_category === ""
                        ? BLACK.B_40
                        : BLACK.B_100,
                  }}
                  value={createState?.principal_category}
                  onChange={(e) =>
                    setCreateState((prev) => ({
                      ...prev,
                      ["principal_category"]: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            {/* Main Category */}

            <div
              className=" pt-6 flex flex-col "
              style={{ backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Main Category
              </div>
              <Autocomplete
                value={
                  othername === "" ||
                  // othername === "PRINCIPAL" ||
                  othername === "CATEGORY" ||
                  othername === "SUB"
                    ? createState?.main_cat_id
                      ? suggestMains.find(
                          (p) => p.main_category_id === createState?.main_cat_id
                        )
                      : { main_category: "", main_category_id: "" }
                    : { main_category: "Other", main_category_id: "" }
                }
                placeholder="Search Value"
                options={
                  suggestMains?.length ? (suggestMains as readonly any[]) : []
                }
                getOptionLabel={(option) => option.main_category}
                onChange={(event, newValue) => {
                  // Check if newValue is null or undefined
                  if (newValue) {
                    if (newValue.main_category_id) {
                      onSelectChangeHandler(
                        "main_cat_id",
                        newValue.main_category_id
                      );
                      setOtherName("");
                    } else if (newValue.main_category === "Other") {
                      setOtherName("MAIN");
                      onSelectChangeHandler("main_cat_id", "");
                    } else {
                      onSelectChangeHandler("main_cat_id", "");
                      setOtherName("");
                    }
                  } else {
                    // Handle case when newValue is null or undefined
                    onSelectChangeHandler("main_cat_id", "");
                    setOtherName("");
                    setCreateState((prev) => ({
                      ...prev,
                      cat_id: "",
                      sub_cat_id: "",
                      main_category: "",
                      category: "",
                      sub_category: "",
                    }));
                  }
                }}
                filterOptions={(options, state) => {
                  const { inputValue } = state;
                  let arr = [];
                  if (Array.isArray(options)) {
                    arr = options.filter((option) =>
                      option.main_category
                        .toLowerCase()
                        .includes(inputValue?.toLowerCase())
                    );
                    if (arr.length === 0) {
                      arr.push({
                        main_category: "Other",
                        main_category_id: "" as UUID,
                      });
                    }
                  }
                  return arr;
                }}
                disabled={
                  (createState?.principal_id === "" && hierarchy_level > 3) ||
                  (othername === "PRINCIPAL" && true)
                }
                sx={{
                  width: "100%",
                  height: 52,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  borderRadius: 8,
                  "--Input-focusedThickness": "0px",
                  ":focus-within": {
                    border: `1px solid ${BLACK.B_10}`,
                  },
                  backgroundColor: WHITE.W_100,
                  color:
                    createState?.main_cat_id === "" && othername === ""
                      ? BLACK.B_40
                      : BLACK.B_100,
                  boxShadow: "none",
                  "&.Mui-disabled": {
                    bgcolor: BLACK.B_10,
                  },
                }}
              />
            </div>

            {(othername === "PRINCIPAL" || othername === "MAIN") && (
              <div className="pt-6" style={{ backgroundColor: WHITE.W_100 }}>
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#5B5B5B",
                  }}
                >
                  Other Main Category
                </div>
                <Input
                  placeholder="Add Other Main Category"
                  sx={{
                    "--Input-focusedThickness": "0px",
                    // width: "340px",
                    height: "52px",
                    backgroundColor: WHITE.W_100,
                    border: `1px solid ${BLACK.B_10}`,
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    color:
                      createState && createState?.main_category === ""
                        ? BLACK.B_40
                        : BLACK.B_100,
                  }}
                  value={createState?.main_category}
                  onChange={(e) =>
                    setCreateState((prev) => ({
                      ...prev,
                      ["main_category"]: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            {/*Category */}
            <div
              className=" pt-6 flex flex-col"
              style={{ backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Category
              </div>
              <Autocomplete
                value={
                  othername === "" ||
                  // othername === "PRINCIPAL" ||
                  // othername === "MAIN" ||
                  othername === "SUB"
                    ? createState?.cat_id
                      ? suggestCategorys.find(
                          (p) => p?.category_id === createState?.cat_id
                        )
                      : { category: "", category_id: "" }
                    : { category: "Other", category_id: "" }
                }
                placeholder="Search Value"
                options={
                  suggestCategorys?.length
                    ? (suggestCategorys as readonly any[])
                    : []
                }
                getOptionLabel={(option) => option.category}
                onChange={(event, newValue) => {
                  // Check if newValue is null or undefined
                  if (newValue) {
                    if (newValue.category_id) {
                      onSelectChangeHandler("cat_id", newValue.category_id);
                      setOtherName("");
                    } else if (newValue.category === "Other") {
                      setOtherName("CATEGORY");
                      onSelectChangeHandler("cat_id", "");
                    } else {
                      onSelectChangeHandler("cat_id", "");
                      setOtherName("");
                    }
                  } else {
                    // Handle case when newValue is null or undefined
                    onSelectChangeHandler("cat_id", "");
                    setOtherName("");
                    setCreateState((prev) => ({
                      ...prev,
                      category: "",
                      sub_category: "",
                      sub_cat_id: "",
                    }));
                  }
                }}
                filterOptions={(options, state) => {
                  const { inputValue } = state;
                  let arr = [];
                  if (Array.isArray(options)) {
                    arr = options.filter((option) =>
                      option.category
                        .toLowerCase()
                        .includes(inputValue?.toLowerCase())
                    );
                    if (arr.length === 0) {
                      arr.push({
                        category: "Other",
                        category_id: "" as UUID,
                      });
                    }
                  }
                  return arr;
                }}
                disabled={
                  createState?.principal_id === "" ||
                  (createState?.main_cat_id === "" && hierarchy_level > 2) ||
                  (othername === "MAIN" && true)
                }
                sx={{
                  width: "100%",
                  height: 52,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  borderRadius: 8,
                  "--Input-focusedThickness": "0px",
                  ":focus-within": {
                    border: `1px solid ${BLACK.B_10}`,
                  },
                  backgroundColor: WHITE.W_100,
                  color:
                    createState?.cat_id === "" && othername === ""
                      ? BLACK.B_40
                      : BLACK.B_100,
                  boxShadow: "none",
                  "&.Mui-disabled": {
                    bgcolor: BLACK.B_10,
                  },
                }}
              />
            </div>

            {(othername === "PRINCIPAL" ||
              othername === "MAIN" ||
              othername === "CATEGORY") && (
              <div className="pt-6" style={{ backgroundColor: WHITE.W_100 }}>
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#5B5B5B",
                  }}
                >
                  Other Category
                </div>
                <Input
                  placeholder="Add Other Category"
                  sx={{
                    "--Input-focusedThickness": "0px",
                    // width: "340px",
                    height: "52px",
                    backgroundColor: WHITE.W_100,
                    border: `1px solid ${BLACK.B_10}`,
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    color:
                      createState && createState?.category === ""
                        ? BLACK.B_40
                        : BLACK.B_100,
                  }}
                  value={createState?.category}
                  onChange={(e) =>
                    setCreateState((prev) => ({
                      ...prev,
                      ["category"]: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            {/* Sub Category */}
            <div
              className=" pt-6 flex flex-col "
              style={{ backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Sub-Category
              </div>
              <Autocomplete
                value={
                  othername === ""
                    ? // othername === "PRINCIPAL" ||
                      // othername === "MAIN" ||
                      // othername === "CATEGORY"
                      createState?.sub_cat_id
                      ? suggestSubCategorys.find(
                          (p) => p.sub_category_id === createState?.sub_cat_id
                        )
                      : { sub_category: "", sub_category_id: "" as UUID }
                    : { sub_category: "Other", sub_category_id: "" }
                }
                placeholder="Search Value"
                options={
                  suggestSubCategorys?.length
                    ? (suggestSubCategorys as readonly any[])
                    : []
                }
                getOptionLabel={(option) => option.sub_category}
                onChange={(event, newValue) => {
                  // Check if newValue is null or undefined
                  if (newValue) {
                    if (newValue.sub_category_id) {
                      onSelectChangeHandler(
                        "sub_cat_id",
                        newValue.sub_category_id
                      );
                      setOtherName("");
                    } else if (newValue.sub_category === "Other") {
                      setOtherName("SUB");
                      onSelectChangeHandler("sub_cat_id", "");
                    } else {
                      onSelectChangeHandler("sub_cat_id", "");
                      setOtherName("");
                    }
                  } else {
                    // Handle case when newValue is null or undefined
                    onSelectChangeHandler("sub_cat_id", "");
                    setOtherName("");
                    setCreateState((prev) => ({
                      ...prev,
                      sub_category: "",
                    }));
                  }
                }}
                filterOptions={(options, state) => {
                  const { inputValue } = state;
                  let arr = [];
                  if (Array.isArray(options)) {
                    arr = options.filter((option) =>
                      option.sub_category
                        .toLowerCase()
                        .includes(inputValue?.toLowerCase())
                    );
                    if (arr.length === 0) {
                      arr.push({
                        sub_category: "Other",
                        sub_category_id: "" as UUID,
                      });
                    }
                  }
                  return arr;
                }}
                disabled={
                  createState?.principal_id === "" ||
                  createState?.main_cat_id === "" ||
                  (createState?.cat_id === "" && hierarchy_level > 1) ||
                  (othername === "CATEGORY" && true)
                }
                sx={{
                  width: "100%",
                  height: 52,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  borderRadius: 8,
                  "--Input-focusedThickness": "0px",
                  ":focus-within": {
                    border: `1px solid ${BLACK.B_10}`,
                  },
                  backgroundColor: WHITE.W_100,
                  color:
                    createState?.sub_cat_id === "" && othername === ""
                      ? BLACK.B_40
                      : BLACK.B_100,
                  boxShadow: "none",
                  "&.Mui-disabled": {
                    bgcolor: BLACK.B_10,
                  },
                }}
              />
            </div>

            {(othername === "PRINCIPAL" ||
              othername === "MAIN" ||
              othername === "CATEGORY" ||
              othername === "SUB") && (
              <div
                className="pt-6 pb-6"
                style={{ backgroundColor: WHITE.W_100 }}
              >
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#5B5B5B",
                  }}
                >
                  Other Sub-Category
                </div>
                <Input
                  placeholder="Add Other Sub-Category"
                  sx={{
                    "--Input-focusedThickness": "0px",
                    // width: "340px",
                    height: "52px",
                    backgroundColor: WHITE.W_100,
                    border: `1px solid ${BLACK.B_10}`,
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    color:
                      createState && createState?.sub_category === ""
                        ? BLACK.B_40
                        : BLACK.B_100,
                  }}
                  value={createState?.sub_category}
                  onChange={(e) =>
                    setCreateState((prev) => ({
                      ...prev,
                      ["sub_category"]: e.target.value,
                    }))
                  }
                />
              </div>
            )}
          </DialogContent>
        )}

        {hierarchy_level === 3 && (
          <DialogContent
            sx={{
              paddingX: "24px",
              backgroundColor: WHITE.W_100,
            }}
          >
            {/* Main Category */}
            <div
              className=" pt-6 flex flex-col "
              style={{ backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Main Category
              </div>
              <Autocomplete
                value={
                  othername === "" ||
                  othername === "CATEGORY" ||
                  othername === "SUB"
                    ? createState?.main_cat_id
                      ? suggestMains.find(
                          (p) => p.main_category_id === createState?.main_cat_id
                        )
                      : { main_category: "", main_category_id: "" }
                    : { main_category: "Other", main_category_id: "" }
                }
                placeholder="Search Value"
                options={
                  suggestMains?.length ? (suggestMains as readonly any[]) : []
                }
                getOptionLabel={(option) => option.main_category}
                onChange={(event, newValue) => {
                  // Check if newValue is null or undefined
                  if (newValue) {
                    if (newValue.main_category_id) {
                      onSelectChangeHandler(
                        "main_cat_id",
                        newValue.main_category_id
                      );
                      setOtherName("");
                    } else if (newValue.main_category === "Other") {
                      setOtherName("MAIN");
                      onSelectChangeHandler("main_cat_id", "");
                    } else {
                      onSelectChangeHandler("main_cat_id", "");
                      setOtherName("");
                    }
                  } else {
                    // Handle case when newValue is null or undefined
                    onSelectChangeHandler("main_cat_id", "");
                    setOtherName("");
                    setCreateState((prev) => ({
                      ...prev,
                      cat_id: "",
                      sub_cat_id: "",
                      main_category: "",
                      category: "",
                      sub_category: "",
                    }));
                  }
                }}
                filterOptions={(options, state) => {
                  const { inputValue } = state;
                  let arr = [];
                  if (Array.isArray(options)) {
                    arr = options.filter((option) =>
                      option.main_category
                        .toLowerCase()
                        .includes(inputValue?.toLowerCase())
                    );
                    if (arr.length === 0) {
                      arr.push({
                        main_category: "Other",
                        main_category_id: "" as UUID,
                      });
                    }
                  }
                  return arr;
                }}
                sx={{
                  width: "100%",
                  height: 52,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  borderRadius: 8,
                  "--Input-focusedThickness": "0px",
                  ":focus-within": {
                    border: `1px solid ${BLACK.B_10}`,
                  },
                  backgroundColor: WHITE.W_100,
                  color:
                    createState?.main_cat_id === "" && othername === ""
                      ? BLACK.B_40
                      : BLACK.B_100,
                  boxShadow: "none",
                  "&.Mui-disabled": {
                    bgcolor: BLACK.B_10,
                  },
                }}
              />
            </div>

            {othername === "MAIN" && (
              <div className="pt-6" style={{ backgroundColor: WHITE.W_100 }}>
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#5B5B5B",
                  }}
                >
                  Other Main Category
                </div>
                <Input
                  placeholder="Add Other Main Category"
                  sx={{
                    "--Input-focusedThickness": "0px",
                    // width: "340px",
                    height: "52px",
                    backgroundColor: WHITE.W_100,
                    border: `1px solid ${BLACK.B_10}`,
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    color:
                      createState && createState?.main_category === ""
                        ? BLACK.B_40
                        : BLACK.B_100,
                  }}
                  value={createState?.main_category}
                  onChange={(e) =>
                    setCreateState((prev) => ({
                      ...prev,
                      ["main_category"]: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            {/*Category */}
            <div
              className=" pt-6 flex flex-col"
              style={{ backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Category
              </div>
              <Autocomplete
                value={
                  othername === "" ||
                  // othername === "MAIN" ||
                  othername === "SUB"
                    ? createState?.cat_id
                      ? suggestCategorys.find(
                          (p) => p?.category_id === createState?.cat_id
                        )
                      : { category: "", category_id: "" }
                    : { category: "Other", category_id: "" }
                }
                placeholder="Search Value"
                options={
                  suggestCategorys?.length
                    ? (suggestCategorys as readonly any[])
                    : []
                }
                getOptionLabel={(option) => option.category}
                onChange={(event, newValue) => {
                  // Check if newValue is null or undefined
                  if (newValue) {
                    if (newValue.category_id) {
                      onSelectChangeHandler("cat_id", newValue.category_id);
                      setOtherName("");
                    } else if (newValue.category === "Other") {
                      setOtherName("CATEGORY");
                      onSelectChangeHandler("cat_id", "");
                    } else {
                      onSelectChangeHandler("cat_id", "");
                      setOtherName("");
                    }
                  } else {
                    // Handle case when newValue is null or undefined
                    onSelectChangeHandler("cat_id", "");
                    setOtherName("");
                    setCreateState((prev) => ({
                      ...prev,
                      category: "",
                      sub_category: "",
                      sub_cat_id: "",
                    }));
                  }
                }}
                filterOptions={(options, state) => {
                  const { inputValue } = state;
                  let arr = [];
                  if (Array.isArray(options)) {
                    arr = options.filter((option) =>
                      option.category
                        .toLowerCase()
                        .includes(inputValue?.toLowerCase())
                    );
                    if (arr.length === 0) {
                      arr.push({
                        category: "Other",
                        category_id: "" as UUID,
                      });
                    }
                  }
                  return arr;
                }}
                disabled={
                  (createState?.main_cat_id === "" && hierarchy_level > 2) ||
                  (othername === "MAIN" && true)
                }
                sx={{
                  width: "100%",
                  height: 52,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  borderRadius: 8,
                  "--Input-focusedThickness": "0px",
                  ":focus-within": {
                    border: `1px solid ${BLACK.B_10}`,
                  },
                  backgroundColor: WHITE.W_100,
                  color:
                    createState?.cat_id === "" && othername === ""
                      ? BLACK.B_40
                      : BLACK.B_100,
                  boxShadow: "none",
                  "&.Mui-disabled": {
                    bgcolor: BLACK.B_10,
                  },
                }}
              />
            </div>

            {(othername === "MAIN" || othername === "CATEGORY") && (
              <div className="pt-6" style={{ backgroundColor: WHITE.W_100 }}>
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#5B5B5B",
                  }}
                >
                  Other Category
                </div>
                <Input
                  placeholder="Add Other Category"
                  sx={{
                    "--Input-focusedThickness": "0px",
                    // width: "340px",
                    height: "52px",
                    backgroundColor: WHITE.W_100,
                    border: `1px solid ${BLACK.B_10}`,
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    color:
                      createState && createState?.category === ""
                        ? BLACK.B_40
                        : BLACK.B_100,
                  }}
                  value={createState?.category}
                  onChange={(e) =>
                    setCreateState((prev) => ({
                      ...prev,
                      ["category"]: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            {/* Sub Category */}
            <div
              className=" pt-6 flex flex-col "
              style={{ backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Sub-Category
              </div>
              <Autocomplete
                value={
                  othername === ""
                    ? // othername === "MAIN" ||
                      // othername === "CATEGORY"
                      createState?.sub_cat_id
                      ? suggestSubCategorys.find(
                          (p) => p.sub_category_id === createState?.sub_cat_id
                        )
                      : { sub_category: "", sub_category_id: "" as UUID }
                    : { sub_category: "Other", sub_category_id: "" }
                }
                placeholder="Search Value"
                options={
                  suggestSubCategorys?.length
                    ? (suggestSubCategorys as readonly any[])
                    : []
                }
                getOptionLabel={(option) => option.sub_category}
                onChange={(event, newValue) => {
                  // Check if newValue is null or undefined
                  if (newValue) {
                    if (newValue.sub_category_id) {
                      onSelectChangeHandler(
                        "sub_cat_id",
                        newValue.sub_category_id
                      );
                      setOtherName("");
                    } else if (newValue.sub_category === "Other") {
                      setOtherName("SUB");
                      onSelectChangeHandler("sub_cat_id", "");
                    } else {
                      onSelectChangeHandler("sub_cat_id", "");
                      setOtherName("");
                    }
                  } else {
                    // Handle case when newValue is null or undefined
                    onSelectChangeHandler("sub_cat_id", "");
                    setOtherName("");
                    setCreateState((prev) => ({
                      ...prev,
                      sub_category: "",
                    }));
                  }
                }}
                filterOptions={(options, state) => {
                  const { inputValue } = state;
                  let arr = [];
                  if (Array.isArray(options)) {
                    arr = options.filter((option) =>
                      option.sub_category
                        .toLowerCase()
                        .includes(inputValue?.toLowerCase())
                    );
                    if (arr.length === 0) {
                      arr.push({
                        sub_category: "Other",
                        sub_category_id: "" as UUID,
                      });
                    }
                  }
                  return arr;
                }}
                disabled={
                  ((createState?.main_cat_id === "" ||
                    createState?.cat_id === "") &&
                    hierarchy_level > 1) ||
                  (othername === "CATEGORY" && true)
                }
                sx={{
                  width: "100%",
                  height: 52,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  borderRadius: 8,
                  "--Input-focusedThickness": "0px",
                  ":focus-within": {
                    border: `1px solid ${BLACK.B_10}`,
                  },
                  backgroundColor: WHITE.W_100,
                  color:
                    createState?.sub_cat_id === "" && othername === ""
                      ? BLACK.B_40
                      : BLACK.B_100,
                  boxShadow: "none",
                  "&.Mui-disabled": {
                    bgcolor: BLACK.B_10,
                  },
                }}
              />
            </div>

            {(othername === "MAIN" ||
              othername === "CATEGORY" ||
              othername === "SUB") && (
              <div
                className="pt-6 pb-6"
                style={{ backgroundColor: WHITE.W_100 }}
              >
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#5B5B5B",
                  }}
                >
                  Other Sub-Category
                </div>
                <Input
                  placeholder="Add Other Sub-Category"
                  sx={{
                    "--Input-focusedThickness": "0px",
                    // width: "340px",
                    height: "52px",
                    backgroundColor: WHITE.W_100,
                    border: `1px solid ${BLACK.B_10}`,
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    color:
                      createState && createState?.sub_category === ""
                        ? BLACK.B_40
                        : BLACK.B_100,
                  }}
                  value={createState?.sub_category}
                  onChange={(e) =>
                    setCreateState((prev) => ({
                      ...prev,
                      ["sub_category"]: e.target.value,
                    }))
                  }
                />
              </div>
            )}
          </DialogContent>
        )}

        {hierarchy_level === 2 && (
          <DialogContent
            sx={{
              paddingX: "24px",
              backgroundColor: WHITE.W_100,
            }}
          >
            {/*Category */}
            <div
              className=" pt-6 flex flex-col"
              style={{ backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Category
              </div>
              <Autocomplete
                value={
                  othername === "" || othername === "SUB"
                    ? createState?.cat_id
                      ? suggestCategorys.find(
                          (p) => p?.category_id === createState?.cat_id
                        )
                      : { category: "", category_id: "" }
                    : { category: "Other", category_id: "" }
                }
                placeholder="Search Value"
                options={
                  suggestCategorys?.length
                    ? (suggestCategorys as readonly any[])
                    : []
                }
                getOptionLabel={(option) => option.category}
                onChange={(event, newValue) => {
                  // Check if newValue is null or undefined
                  if (newValue) {
                    if (newValue.category_id) {
                      onSelectChangeHandler("cat_id", newValue.category_id);
                      setOtherName("");
                    } else if (newValue.category === "Other") {
                      setOtherName("CATEGORY");
                      onSelectChangeHandler("cat_id", "");
                    } else {
                      onSelectChangeHandler("cat_id", "");
                      setOtherName("");
                    }
                  } else {
                    // Handle case when newValue is null or undefined
                    onSelectChangeHandler("cat_id", "");
                    setOtherName("");
                    setCreateState((prev) => ({
                      ...prev,
                      category: "",
                      sub_category: "",
                      sub_cat_id: "",
                    }));
                  }
                }}
                filterOptions={(options, state) => {
                  const { inputValue } = state;
                  let arr = [];
                  if (Array.isArray(options)) {
                    arr = options.filter((option) =>
                      option.category
                        .toLowerCase()
                        .includes(inputValue?.toLowerCase())
                    );
                    if (arr.length === 0) {
                      arr.push({
                        category: "Other",
                        category_id: "" as UUID,
                      });
                    }
                  }
                  return arr;
                }}
                disabled={
                  (createState?.main_cat_id === "" && hierarchy_level > 2) ||
                  (othername === "MAIN" && true)
                }
                sx={{
                  width: "100%",
                  height: 52,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  borderRadius: 8,
                  "--Input-focusedThickness": "0px",
                  ":focus-within": {
                    border: `1px solid ${BLACK.B_10}`,
                  },
                  backgroundColor: WHITE.W_100,
                  color:
                    createState?.cat_id === "" && othername === ""
                      ? BLACK.B_40
                      : BLACK.B_100,
                  boxShadow: "none",
                  "&.Mui-disabled": {
                    bgcolor: BLACK.B_10,
                  },
                }}
              />
            </div>

            {othername === "CATEGORY" && (
              <div className="pt-6" style={{ backgroundColor: WHITE.W_100 }}>
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#5B5B5B",
                  }}
                >
                  Other Category
                </div>
                <Input
                  placeholder="Add Other Category"
                  sx={{
                    "--Input-focusedThickness": "0px",
                    // width: "340px",
                    height: "52px",
                    backgroundColor: WHITE.W_100,
                    border: `1px solid ${BLACK.B_10}`,
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    color:
                      createState && createState?.category === ""
                        ? BLACK.B_40
                        : BLACK.B_100,
                  }}
                  value={createState?.category}
                  onChange={(e) =>
                    setCreateState((prev) => ({
                      ...prev,
                      ["category"]: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            {/* Sub Category */}
            <div
              className=" pt-6 flex flex-col "
              style={{ backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Sub-Category
              </div>
              <Autocomplete
                value={
                  othername === ""
                    ? // || othername === "CATEGORY"
                      createState?.sub_cat_id
                      ? suggestSubCategorys.find(
                          (p) => p.sub_category_id === createState?.sub_cat_id
                        )
                      : { sub_category: "", sub_category_id: "" as UUID }
                    : { sub_category: "Other", sub_category_id: "" }
                }
                placeholder="Search Value"
                options={
                  suggestSubCategorys?.length
                    ? (suggestSubCategorys as readonly any[])
                    : []
                }
                getOptionLabel={(option) => option.sub_category}
                onChange={(event, newValue) => {
                  // Check if newValue is null or undefined
                  if (newValue) {
                    if (newValue.sub_category_id) {
                      onSelectChangeHandler(
                        "sub_cat_id",
                        newValue.sub_category_id
                      );
                      setOtherName("");
                    } else if (newValue.sub_category === "Other") {
                      setOtherName("SUB");
                      onSelectChangeHandler("sub_cat_id", "");
                    } else {
                      onSelectChangeHandler("sub_cat_id", "");
                      setOtherName("");
                    }
                  } else {
                    // Handle case when newValue is null or undefined
                    onSelectChangeHandler("sub_cat_id", "");
                    setOtherName("");
                    setCreateState((prev) => ({
                      ...prev,
                      sub_category: "",
                    }));
                  }
                }}
                filterOptions={(options, state) => {
                  const { inputValue } = state;
                  let arr = [];
                  if (Array.isArray(options)) {
                    arr = options.filter((option) =>
                      option.sub_category
                        .toLowerCase()
                        .includes(inputValue?.toLowerCase())
                    );
                    if (arr.length === 0) {
                      arr.push({
                        sub_category: "Other",
                        sub_category_id: "" as UUID,
                      });
                    }
                  }
                  return arr;
                }}
                disabled={
                  (createState?.cat_id === "" && hierarchy_level > 1) ||
                  (othername === "CATEGORY" && true)
                }
                sx={{
                  width: "100%",
                  height: 52,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  borderRadius: 8,
                  "--Input-focusedThickness": "0px",
                  ":focus-within": {
                    border: `1px solid ${BLACK.B_10}`,
                  },
                  backgroundColor: WHITE.W_100,
                  color:
                    createState?.sub_cat_id === "" && othername === ""
                      ? BLACK.B_40
                      : BLACK.B_100,
                  boxShadow: "none",
                  "&.Mui-disabled": {
                    bgcolor: BLACK.B_10,
                  },
                }}
              />
            </div>

            {(othername === "CATEGORY" || othername === "SUB") && (
              <div
                className="pt-6 pb-6"
                style={{ backgroundColor: WHITE.W_100 }}
              >
                <div
                  className="mb-1"
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "#5B5B5B",
                  }}
                >
                  Other Sub-Category
                </div>
                <Input
                  placeholder="Add Other Sub-Category"
                  sx={{
                    "--Input-focusedThickness": "0px",
                    // width: "340px",
                    height: "52px",
                    backgroundColor: WHITE.W_100,
                    border: `1px solid ${BLACK.B_10}`,
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    color:
                      createState && createState?.sub_category === ""
                        ? BLACK.B_40
                        : BLACK.B_100,
                  }}
                  value={createState?.sub_category}
                  onChange={(e) =>
                    setCreateState((prev) => ({
                      ...prev,
                      ["sub_category"]: e.target.value,
                    }))
                  }
                />
              </div>
            )}
          </DialogContent>
        )}

        <div
          className="flex items-center justify-center gap-5 px-6"
          style={{
            height: 88,
            borderTop: `1px solid ${BLACK.B_10}`,
            backgroundColor: WHITE.W_100,
          }}
        >
          <Button
            loading={saveloading}
            sx={{
              height: 40,
              width: "100%",
              fontSize: 14,
              fontWeight: 500,
              backgroundColor: PRIMARY.P_BLue,
              lineHeight: "20px",
              borderRadius: 8,
            }}
            onClick={saveAddCategoryHandler}
          >
            Save
          </Button>
        </div>
      </Drawer>

      {/* Edit Drawer */}
      <Drawer key={"right"} anchor={"right"} open={editToggle} size="md">
        <div
          className="flex p-6 items-start justify-between gap-10"
          style={{ height: 72, borderBottom: `1px solid ${BLACK.B_10}` }}
        >
          <div
            className="self-stretch"
            style={{
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              color: BLACK.B_100,
            }}
          >
            Edit Category
          </div>
          <div
            className="w-fit cursor-pointer"
            onClick={() => {
              // onClearFilterHandler();
              setEditToggle(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                fill="#1C1C1C"
              />
            </svg>
          </div>
        </div>
        <DialogContent
          sx={{
            paddingX: "24px",
            backgroundColor: WHITE.W_100,
          }}
        >
          {hierarchy_level === 4 && (
            <div
              className="pt-6 mb-6"
              style={{ height: 76, backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Principle Category
              </div>
              <Input
                placeholder="Enter Keyword"
                sx={{
                  "--Input-focusedThickness": "0px",
                  // width: "340px",
                  height: "52px",
                  backgroundColor: WHITE.W_100,
                  border: `1px solid ${BLACK.B_10}`,
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  color:
                    editData?.principal_cat === "" ? BLACK.B_40 : BLACK.B_100,
                }}
                value={editData?.principal_cat}
                onChange={(e) =>
                  setEditData((prev) => ({
                    ...prev,
                    ["principal_cat"]: e.target.value,
                  }))
                }
              />
            </div>
          )}
          {(hierarchy_level === 4 || hierarchy_level === 3) && (
            <div
              className="pt-6 mb-6"
              style={{ height: 76, backgroundColor: WHITE.W_100 }}
            >
              <div
                className="mb-1"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#5B5B5B",
                }}
              >
                Main Category
              </div>
              <Input
                placeholder="Enter Keyword"
                sx={{
                  "--Input-focusedThickness": "0px",
                  // width: "340px",
                  height: "52px",
                  backgroundColor: WHITE.W_100,
                  border: `1px solid ${BLACK.B_10}`,
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  color: editData?.main_cat === "" ? BLACK.B_40 : BLACK.B_100,
                }}
                value={editData?.main_cat}
                onChange={(e) =>
                  setEditData((prev) => ({
                    ...prev,
                    ["main_cat"]: e.target.value,
                  }))
                }
              />
            </div>
          )}
          <div
            className="pt-6 mb-6"
            style={{ height: 76, backgroundColor: WHITE.W_100 }}
          >
            <div
              className="mb-1"
              style={{
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                color: "#5B5B5B",
              }}
            >
              Category
            </div>
            <Input
              placeholder="Enter Keyword"
              sx={{
                "--Input-focusedThickness": "0px",
                // width: "340px",
                height: "52px",
                backgroundColor: WHITE.W_100,
                border: `1px solid ${BLACK.B_10}`,
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                color: editData?.cat === "" ? BLACK.B_40 : BLACK.B_100,
              }}
              value={editData?.cat}
              onChange={(e) =>
                setEditData((prev) => ({ ...prev, ["cat"]: e.target.value }))
              }
            />
          </div>
          <div
            className="pt-6 mb-6"
            style={{ height: 76, backgroundColor: WHITE.W_100 }}
          >
            <div
              className="mb-1"
              style={{
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                color: "#5B5B5B",
              }}
            >
              Sub-Category
            </div>
            <Input
              placeholder="Enter Keyword"
              sx={{
                "--Input-focusedThickness": "0px",
                // width: "340px",
                height: "52px",
                backgroundColor: WHITE.W_100,
                border: `1px solid ${BLACK.B_10}`,
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                color: editData?.sub_cat === "" ? BLACK.B_40 : BLACK.B_100,
              }}
              value={editData?.sub_cat}
              onChange={(e) =>
                setEditData((prev) => ({
                  ...prev,
                  ["sub_cat"]: e.target.value,
                }))
              }
            />
          </div>
        </DialogContent>
        <div
          className="flex items-center justify-center gap-5 px-6"
          style={{
            height: 88,
            borderTop: `1px solid ${BLACK.B_10}`,
            backgroundColor: WHITE.W_100,
          }}
        >
          <Button
            loading={editloading}
            sx={{
              height: 40,
              width: "100%",
              fontSize: 18,
              fontWeight: 500,
              paddingY: "8px",
              backgroundColor: PRIMARY.P_BLue,
              color: "#FFF",
              lineHeight: "24px",
              borderRadius: 8,
            }}
            onClick={UpdateCategoryHandler}
          >
            Save
          </Button>
        </div>
      </Drawer>
    </>
  );
};

export default CategoryList;
